/**
 * Gera IDs de teste padronizados para os componentes e seus subcomponentes.
 * @param prefix - Prefixo do componente a ser usado nos data-testid.
 * @returns Um objeto com os testIds para o componente e seus subcomponentes.
 */
export const generateTestId = (prefix = 'component') => {
  return {
    component: `${prefix}`,
    input: `${prefix}-input`,
    popover: `${prefix}-popover`,
    content: `${prefix}-content`,
    // Outros elementos comuns que podem ser reutilizados
    label: `${prefix}-label`,
    icon: `${prefix}-icon`,
    button: `${prefix}-button`,
    dropdown: `${prefix}-dropdown`,
  };
};
